module.exports = __webpack_public_path__ + "img/bg2.f3ee59a7.png";